import React from 'react'
import { Link } from 'react-router-dom'

export default (props) => {
  return (
    <Link to={`/${props.eventSlug}/${props.race.id}`}>
      <p className='center'>{props.race.name}</p>
      <p className='center'>{props.race.distance} km</p>
    </Link>
  )
}
